      import React from 'react';
      import inter1 from "../landing_page_brand/international01.webp"
      import inter2 from "../landing_page_brand/international20.webp"
      import inter3 from "../landing_page_brand/international30.webp"
      import inter4 from "../landing_page_brand/international04.webp"
      import inter5 from "../landing_page_brand/international05.webp"
      import inter6 from "../landing_page_brand/international06.webp"
      import inter7 from "../landing_page_brand/international07.webp"
      import inter8 from "../landing_page_brand/international08.webp"
      import inter9 from "../landing_page_brand/international09.webp"
      import inter10 from "../landing_page_brand/international10.webp"
      import inter11 from "../landing_page_brand/international11.webp"
      import inter12 from "../landing_page_brand/international12.webp"
      import inter13 from "../landing_page_brand/international13.webp"
      import inter14 from "../landing_page_brand/international14.webp"
      import inter15 from "../landing_page_brand/international15.webp"
      import inter16 from "../landing_page_brand/international16.webp"
      import inter17 from "../landing_page_brand/international17.webp"
      import inter18 from "../landing_page_brand/international18.webp"
      import inter19 from "../landing_page_brand/international19.webp"
      import inter20 from "../landing_page_brand/international20.webp"
      import inter21 from "../landing_page_brand/international21.webp"
      import inter22 from "../landing_page_brand/international22.webp"
      import inter23 from "../landing_page_brand/international23.webp"
      import inter24 from "../landing_page_brand/international24.webp"
      import inter25 from "../landing_page_brand/international25.webp"
      import inter26 from "../landing_page_brand/international26.webp"
      import inter27 from "../landing_page_brand/international27.webp"
      import inter28 from "../landing_page_brand/international28.webp"
      import inter29 from "../landing_page_brand/international29.webp"
      import inter30 from "../landing_page_brand/international30.webp"

      import rec1 from "../landing_page_brand/toprecruiter01.webp"
      import rec2 from "../landing_page_brand/toprecruiter02.webp"
      import rec3 from "../landing_page_brand/toprecruiter03.webp"
      import rec4 from "../landing_page_brand/toprecruiter04.webp"
      import rec5 from "../landing_page_brand/toprecruiter05.webp"
      import rec6 from "../landing_page_brand/toprecruiter06.webp"
      import rec7 from "../landing_page_brand/toprecruiter07.webp"
      import rec8 from "../landing_page_brand/toprecruiter08.webp"
      import rec9 from "../landing_page_brand/toprecruiter09.webp"
      import rec10 from "../landing_page_brand/toprecruiter10.webp"
      import rec11 from "../landing_page_brand/toprecruiter11.webp"
      import rec12 from "../landing_page_brand/toprecruiter12.webp"
      import rec13 from "../landing_page_brand/toprecruiter13.webp"
      import rec14 from "../landing_page_brand/toprecruiter14.webp"
      import rec15 from "../landing_page_brand/toprecruiter15.webp"
      import rec16 from "../landing_page_brand/toprecruiter16.webp"
      import rec17 from "../landing_page_brand/toprecruiter17.webp"
      import rec18 from "../landing_page_brand/toprecruiter18.webp"
      import rec19 from "../landing_page_brand/toprecruiter19.webp"
      import rec20 from "../landing_page_brand/toprecruiter20.webp"
      import rec21 from "../landing_page_brand/toprecruiter21.webp"
      import rec22 from "../landing_page_brand/toprecruiter22.webp"
      import rec23 from "../landing_page_brand/toprecruiter23.webp"
      import rec24 from "../landing_page_brand/toprecruiter24.webp"
      import rec25 from "../landing_page_brand/toprecruiter25.webp"
      import rec26 from "../landing_page_brand/toprecruiter26.webp"
      import rec27 from "../landing_page_brand/toprecruiter27.webp"
      import rec28 from "../landing_page_brand/toprecruiter28.webp"
      import rec30 from "../landing_page_brand/toprecruiter30.webp"
      import rec31 from "../landing_page_brand/toprecruiter31.webp"
      import rec32 from "../landing_page_brand/toprecruiter32.webp"
      import rec33 from "../landing_page_brand/toprecruiter33.webp"

      import icon1 from "../icon-img/icon1.webp"
      import icon2 from "../icon-img/icon2.webp"
      import icon3 from "../icon-img/icon3.webp"
      import icon4 from "../icon-img/icon4.webp"
      import icon5 from "../icon-img/icon5.webp"
      import icon6 from "../icon-img/icon6.webp"
      import icon7 from "../icon-img/icon7.webp"
      import icon8 from "../icon-img/icon8.webp"
      import icon9 from "../icon-img/icon9.webp"

      import banner from "../Testi Images/banner.png"
      import prof1 from "../Testi Images/prof1.png"
      import prof2 from "../Testi Images/prof2.png"
      import prof3 from "../Testi Images/prof3.png"
      import { useState} from 'react';
      import TestimonialCarousel from '../Components/TestimonialCarousel';
      import Form from '../Components/Form';
      import ApplyNowButton from '../Components/ApplyNowButton';
      const recruiters = [
      [
      { img: inter1, name: "Go First" },
      { img: inter2, name: "Haier" },
      { img: inter3, name: "BIBA" },
      { img: inter4, name: "HDFC" },
      { img: inter5, name: "Dr. Reddy's" },
      { img: inter6, name: "Incedo" }
      ],
      [
      { img: inter7, name: "Go First" },
      { img: inter8, name: "Haier" },
      { img: inter9, name: "BIBA" },
      { img: inter10, name: "HDFC" },
      { img: inter11, name: "Dr. Reddy's" },
      { img: inter12, name: "Incedo" }
      ],
      [
      { img: inter13, name: "Go First" },
      { img: inter14, name: "Haier" },
      { img: inter15, name: "BIBA" },
      { img: inter16, name: "HDFC" },
      { img: inter17, name: "Dr. Reddy's" },
      { img: inter18, name: "Incedo" }
      ],
      [
      { img: inter19, name: "Go First" },
      { img: inter20, name: "Haier" },
      { img: inter21, name: "BIBA" },
      { img: inter22, name: "HDFC" },
      { img: inter23, name: "Dr. Reddy's" },
      { img: inter24, name: "Incedo" }
      ],
      [
      { img: inter25, name: "Go First" },
      { img: inter26, name: "Haier" },
      { img: inter27, name: "BIBA" },
      { img: inter28, name: "HDFC" },
      { img: inter29, name: "Dr. Reddy's" },
      { img: inter30, name: "Incedo" }
      ],
      ];
      const partners = [
      [
      { img: rec1, name: "University of Edinburgh" },
      { img: rec2, name: "Berkeley Global" },
      { img: rec3, name: "University of Queensland" },
      { img: rec4, name: "University of Adelaide" },
      { img: rec5, name: "University of Edinburgh" },
      { img: rec6, name: "Berkeley Global" },
      { img: rec7, name: "University of Queensland" },
      { img: rec8, name: "University of Adelaide" },
      ],
      [
      { img: rec9, name: "University of Auckland" },
      { img: rec10, name: "UNSW Sydney" },
      { img: rec11, name: "Nottingham Trent University" },
      { img: rec12, name: "IED" },
      { img: rec13, name: "University of Auckland" },
      { img: rec14, name: "UNSW Sydney" },
      { img: rec15, name: "Nottingham Trent University" },
      { img: rec16, name: "IED" },
      ],
      [
      { img: rec9, name: "University of Auckland" },
      { img: rec10, name: "UNSW Sydney" },
      { img: rec11, name: "Nottingham Trent University" },
      { img: rec12, name: "IED" },
      { img: rec13, name: "University of Auckland" },
      { img: rec14, name: "UNSW Sydney" },
      { img: rec15, name: "Nottingham Trent University" },
      { img: rec16, name: "IED" },
      ],
      [
      { img: rec17, name: "University of Auckland" },
      { img: rec18, name: "UNSW Sydney" },
      { img: rec19, name: "Nottingham Trent University" },
      { img: rec20, name: "IED" },
      { img: rec21, name: "University of Auckland" },
      { img: rec22, name: "UNSW Sydney" },
      { img: rec23, name: "Nottingham Trent University" },
      { img: rec24, name: "IED" },
      ],
      [
      { img: rec25, name: "University of Auckland" },
      { img: rec26, name: "UNSW Sydney" },
      { img: rec27, name: "Nottingham Trent University" },
      { img: rec28, name: "IED" },
      { img: rec33, name: "University of Auckland" },
      { img: rec30, name: "UNSW Sydney" },
      { img: rec31, name: "Nottingham Trent University" },
      { img: rec32, name: "IED" },
      ]
      ];

      const schools = [
      { id: "engineering", name: "School of Advanced Engineering" },
      { id: "business", name: "School of Business" },
      { id: "computer", name: "School of Computer Science" },
      { id: "design", name: "School of Design" },
      { id: "health", name: "School of Health Sciences and Technology" },
      { id: "law", name: "School of Law" },
      { id: "media", name: "School of Liberal Studies & Media" },
      ];
      const programs = {
      engineering: {
      undergraduate: [
      {
      title: "For B.Tech. Programs (CSE):",
      criteria: "Minimum 50% marks in Class X and XII with 50% in PCM.",
      },
      {
      title: "For B.Tech. Programs (ECE):",
      criteria: "Minimum 50% marks in Class X and XII with 50% in PCM.",
      },
      ],
      postgraduate: [
      {
      title: "For M.Tech. Programs (AI & ML):",
      criteria: "Graduation in relevant field with minimum 55% marks.",
      },
      {
      title: "For M.Tech. Programs (Embedded Systems):",
      criteria: "Graduation in relevant field with minimum 55% marks.",
      },
      ],
      },
      business: {
      undergraduate: [
      {
      title: "For BBA Programs:",
      criteria: "Minimum 50% marks in Class XII.",
      },
      ],
      postgraduate: [
      {
      title: "For MBA Programs:",
      criteria: [
      "Graduation in any field with minimum 50% marks.",
      "Selection Criteria: Entrance Exam (UPESMET-UG) / UGAT / CUET.",
      ],
      },
      ],
      },
      computer: {
      undergraduate: [
      {
      title: "For B.Tech. Programs:",
      criteria: "Minimum 50% marks in Class X and XII with 50% in PCM in Class XII.",
      },
      {
      title: "For BCA and B.Sc. Programs:",
      criteria:
      "50% marks in class X and XII with Mathematics/Computer Science/Information Technology as one of the major subjects in Class XII.",
      },
      ],
      postgraduate: [
      {
      title: "For M.Tech. Programs:",
      criteria: [
      "Minimum 60% marks in Class X and XII.",
      "B.Tech/BE (IT/(Hons.) Computer Science and Engineering), MCA, M.Sc. (Physics/Maths/Statistics) with minimum 60% marks.",
      ],
      },
      {
      title: "For MCA Programs:",
      criteria: [
      "Minimum 50% in Class X and XII.",
      "50% aggregate marks in BCA or B.Sc. (Computer Science) or B.Sc. (Information Technology).",
      "Any graduation with Computer Science/IT as a subject for three years OR Mathematics/Statistics/Business Maths/Business Statistics/QT at graduation or 10+2 level.",
      ],
      },
      ],
      },
      design: {
      undergraduate: [
      {
      title: "For all UG Programs:",
      criteria: "Minimum 50% marks in Class X and XII (any stream).",
      },
      ],
      postgraduate: [
      {
      title: "For PG Programs:",
      criteria: [
      "Minimum 50% in Class X & XII.",
      "Minimum 50% marks in bachelor's degree in Design/Engineering/Architecture/Interior Design (10+2+4 years).",
      "OR 2 years M.Sc./M.Tech in Computer Science and Engineering, IT Subjects / Domains (Only for Interaction Design).",
      ],
      },
      ],
      },
      health: {
      undergraduate: [
      {
      title: "For all UG Programs:",
      criteria:
      "Minimum 50% marks in Class X & XII with Physics, Chemistry, Biology/Maths, and English as a major subject in XII.",
      },
      ],
      postgraduate: [
      {
      title: "For M.Sc. Programs:",
      criteria: [
      "Minimum 50% marks in Class X & XII.",
      "Graduation in B.Sc. with Biology/Biotechnology/Pharma/BPT/B.Sc. Food Science Tech./B.Sc. Microbiology/B.Sc. Nursing/BMIT/B.Sc. Environmental Sciences/B.Sc. Dairy Sciences/Biochemistry/B.Sc. Chemistry/B.Sc. Zoology/B.Sc. Food, Nutrition, and Dietetics/Home Science or any equivalent course.",
      ],
      },
      ],
      },
      law: {
      undergraduate: [
      {
      title: "For LLB (3-years) Programs:",
      criteria: [
      "Minimum 50% marks in Class X & XII (Any Stream).",
      "Minimum 50% marks in Graduation (Any Stream).",
      ],
      },
      {
      title: "For LLB (5-years) Programs:",
      criteria: "Minimum 50% marks in Class X and XII.",
      },
      ],
      postgraduate: [
      {
      title: "For LLM Programs:",
      criteria: [
      "Minimum 50% marks in Class X & XII.",
      "Minimum 50% marks in Graduation with LL.B. Degree or equivalent.",
      ],
      },
      ],
      },
      media: {
      undergraduate: [
      {
      title: "For B.Sc. (Hons.) Programs:",
      criteria: [
      "Minimum 50% marks in Class X and XII (any Stream).",
      "A. Math/Economics/Political Science in 12th will be preferred.",
      "B. Non-Mathematics background students will undergo a Remedial Mathematics module in Semester 1.",
      ],
      },
      {
      title: "For BA (Hons.) Programs:",
      criteria: [
      "Minimum 50% marks in Class X and XII (any Stream).",
      "A. Math/Economics/Political Science in 12th will be preferred.",
      "B. Non-mathematics background students will undergo the Remedial Mathematics module in Semester 1.",
      ],
      },
      {
      title: "For BA Programs:",
      criteria: "Minimum 50% marks in Class X and XII (any Stream).",
      },
      ],
      postgraduate: [
      {
      title: "For MA Programs:",
      criteria: [
      "Minimum 50% marks in Class X, XII (any Stream).",
      "Minimum 50% scores in Graduation.",
      ],
      },
      ],
      },
      };


      const Home = () => {
      const [selectedSchool, setSelectedSchool] = useState("engineering");
      const [selectedLevel, setSelectedLevel] = useState("undergraduate");

      return (
      <>
      <section className="brochure-section" id='hero-section'>
      <div className="container">
      <div className="row justify-content-between align-items-center flex-column-reverse flex-md-row">


      <div className="col-md-6 col-lg-6 brochure-info">
      <h3 className=" programs mb-5 mt-4">
      MBA | B.Tech. | BBA | LL.B. | B.Des. | B.Pharma | BA (Hons.) | B.Sc. <br />
      (Hons.) | BCA | M.Tech. | M.Des. | LL.M. | M.Sc. | MA | MCA <a href="#programes">and more</a>
      </h3>

      <div className="icon-container">
      <div className="row">
      <div className="col-md-6">
      <div className="icon-box">
      <img src={icon1} alt="QS Ranking"  />
      <p><strong>Ranked No. 1</strong> in Academic Reputation*</p>
      </div>
      </div>
      <div className="col-md-6">
      <div className="icon-box">
      <img src={icon2} alt="Top Researchers" />
      <p>45 Faculty among World’s Top 2% Researchers</p>
      </div>
      </div>
      <div className="col-md-6">
      <div className="icon-box">
      <img src={icon3} alt="Esteemed Faculty" />
      <p>Esteemed Faculty from IITs, IISc, and Ivy League Universities</p>
      </div>
      </div>
      <div className="col-md-6">
      <div className="icon-box">
      <img src={icon4} alt="Highest Salary" />
      <p>Highest Package Secured by an Alumnus ₹1.3 Cr</p>
      </div>
      </div>
      </div>
      </div>

      <p className="disclaimer">*QS World University Rankings 2025, among Pvt. Universities</p>
      </div>

      <div className="col-md-5 col-lg-5">
      <Form/>
      </div>
      </div>
      </div>
      <ApplyNowButton/>
      </section>
      <section className='merit-scholorship'>
      <div className="container text-center p-4">

      <div className="row">
      <div className="scholorship text-center">
      <h3 className='mid-title'>Up to 30% Merit Scholarship*</h3>
      <p>*T&C apply. For more details, visit upes.ac.in.</p>
      </div>
      </div>
      </div>
      </section>
      <section className='why-upes' id='why-upes'>
      <div className="why-upes container py-5">
      <h4 className="section-title">Why UPES?</h4>

      <div className="row justify-content-start">
      <div className="col-md-3 col-sm-6 counter">
      <h3>21</h3>
      <p>Years of legacy in multidisciplinary and holistic learning</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>#1</h3>
      <p>Private University in Academic Reputation in India, QS World University Rankings, 2025</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>46</h3>
      <p>Rank in India in University category, NIRF 2024</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>1.3</h3>
      <p>Cr* Highest Package Secured by an Alumnus</p>
      </div>
      </div>

      <div className="row justify-content-start mt-4">
      <div className="col-md-3 col-sm-6 counter">
      <h3>250+</h3>
      <p>Start-ups Supported by Runway Incubator</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>60+</h3>
      <p>Tie-ups with global universities for exceptional international opportunities.</p>
      </div>
      </div>
      <br />
      <div className="line mt-5">
      <p>*In School of Computer Science</p>
      </div>
      </div>
      </section>
      <section className='whychoseus'>
      <div className="why-choose-us container">

      <div className="col-md-6 benefit">
      <div className="icon">
      <img src={icon5} alt="Placement Assistance" />
      </div>
      <p>Lifetime Placement Assistance</p>
      </div>
      <div className="col-md-6 benefit">
      <div className="icon">
      <img src={icon6} alt="Esteemed Faculty" />
      </div>
      <p>Esteemed Faculty from IITs, IISc and Ivy League Universities</p>
      </div>



      <div className="col-md-6 benefit">
      <div className="icon">
      <img src={icon7} alt="Industry Collaboration" />
      </div>
      <p>Industry Collaboration with Microsoft, KPMG, IBM, MG Motors, JSW, L&T, HCLTech and more.</p>
      </div>
      <div className="col-md-6 benefit">
      <div className="icon">
      <img src={icon8} alt="Infrastructure and Labs" />
      </div>
      <p>World-Class Infrastructure and Labs</p>
      </div>



      <div className="col-md-6 benefit">
      <div className="icon">
      <img src={icon9} alt="Scenic Learning" />
      </div>
      <p>Multidisciplinary and Holistic Learning in the Scenic Environs of Dehradun</p>
      </div>



      </div>
      </section>
      <section className="btw-banner">
  <img src={banner} alt="Banner" className="img-fluid w-100" />
</section>

<section className='py-4 mt-5 placements' id='partners'>
      <div className="container mt-5 text-start">
      <h2 className="section-title">International Partners</h2>

      <div id="recruitersCarousel" className="carousel slide" data-bs-ride="carousel">

      {/* Carousel Items */}
      <div className="carousel-inner">
      {recruiters.map((group, index) => (
      <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
      <div className="row">
      {group.map((recruiter, idx) => (
      <div key={idx} className="col-md-4 col-6 d-flex justify-content-center">
      <img width={"100%"} src={recruiter.img} alt={recruiter.name} className="img-fluid recruiter-logo" />
      </div>
      ))}
      </div>
      </div>
      ))}
      </div>

      {/* Custom Navigation Arrows Positioned Below */}
      <div className="carousel-controls text-center mt-3">
      <button className="carousel-control-prev" type="button" data-bs-target="#recruitersCarousel" data-bs-slide="prev">
      <span className="carousel-control-prev-icon"></span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#recruitersCarousel" data-bs-slide="next">
      <span className="carousel-control-next-icon"></span>
      </button>
      </div>
      </div>
      </div>
      </section>

      <section class="py-5">
  <div className="container mt-5 text-start">
  <h2 className="section-title">
  Academic Excellence</h2>
    <div class="row g-4 justify-content-center">

     
      <div class="col-md-4">
        <div class="card   text-start">
          <img src={prof1} class="card-img-top img-fluid"style={{height:"60%"}} alt="Dr. Ram K Sharma"/>
          <div class="card-body">
            <h5 class="card-title fw-bold">Dr. Ram K Sharma</h5>
            <p class="card-text mb-0">Vice Chancellor & Acting Dean - School of Advanced Engineering</p>
          </div>
        </div>
      </div>

      
      <div class="col-md-4">
        <div class="card   text-start">
          <img src={prof2} class="card-img-top img-fluid"style={{height:"60%"}} alt="Prof. Vijaysekhar Chellaboina"/>
          <div class="card-body">
            <h5 class="card-title fw-bold">Prof. Vijaysekhar Chellaboina</h5>
            <p class="card-text mb-1">Dean - School of Computer Science</p>
            <small class="text-muted">Alumnus of IIT Madras, Florida Institute of Technology, and Georgia Tech in Aerospace Engineering.</small>
          </div>
        </div>
      </div>

      
      <div class="col-md-4">
        <div class="card   text-start">
          <img src={prof3} class="card-img-top img-fluid"style={{height:"60%"}} alt="Prof. Bhaskar Bhatt"/>
          <div class="card-body">
            <h5 class="card-title fw-bold">Prof. Bhaskar Bhatt</h5>
            <p class="card-text mb-1">Dean - School of Design</p>
            <small class="text-muted">Alumnus of NID Ahmedabad & IIM Lucknow, design leader, former director at NID, IIT Gandhinagar.</small>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>



      <section id='Placements'>
      <div className="why-upes container py-5" >
      <h4 className="section-title">Placements</h4>

      <div className="row justify-content-start">
      <div className="col-md-3 col-sm-6 counter">
      <h3>1950+</h3>
      <p>Students Placed*

      </p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>

      91%</h3>
      <p>


      Placements*</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>50</h3>
      <p>LPA Highest CTC**</p>
      </div>
      <div className="col-md-3 col-sm-6 counter">
      <h3>590+

      </h3>
      <p>Recruiters on Campus*</p>
      </div>
      </div>

      <br />
      <div className="line mt-5">
      <p>*Placement statistics refer to the number of students who have opted for and are eligible for placements, in 2023-24</p>

      <p>**In School of Computer Science in, 2022-23</p>
      </div>
      </div>
      </section>
      <section className='mt-5 placements' id='ProminentRecruiters'>
      <div className="container mt-5 text-start">
      <h2 className="section-title">Prominent Recruiters</h2>

      <div id="partnersCarousel" className="carousel slide" data-bs-ride="carousel">


      {/* Carousel Items */}
      <div className="carousel-inner">
      {partners.map((group, index) => (
      <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
      <div className="container">
      <div className="row">
      {group.map((partner, idx) => (
      <div key={idx} className="col-md-3 col-6 d-flex justify-content-center">
      <img src={partner.img} alt={partner.name} className="img-fluid" style={{ maxWidth: "200px", height: "auto", margin:"20px" }} />
      </div>
      ))}
      </div>
      </div>
      </div>
      ))}
      </div>

      {/* Custom Navigation Arrows Positioned Below */}
      <div className="carousel-controls text-center mt-3">
      <button className="carousel-control-prev" type="button" data-bs-target="#partnersCarousel" data-bs-slide="prev">
      <span className="carousel-control-prev-icon"></span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#partnersCarousel" data-bs-slide="next">
      <span className="carousel-control-next-icon"></span>
      </button>
      </div>
      </div>


      </div>
      </section>
      <section className="programes" id='programes'>
      <div className="container mt-5">
      {/* Title */}
      <h2 className="mb-4 section-title">Programmes Offered</h2>

      {/* Cards Section */}
      <div className="row">

      {/* Computer Science Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Computer Science</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• B.Tech.</li>
      <li>• B.Sc.</li>
      <li>• BCA</li>
      <li>• M.Tech</li>
      <li>• MCA</li>
      </ul>
      </div>
      </div>
      </div>

      {/* Business Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Business</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• BBA</li>
      <li>• B.Com. (Hons.)</li>
      <li>• MBA</li>
      <li>• Integrated - (BBA) - (MBA)</li>
      <li>• Integrated - B.Com (Hons) - (MBA)</li>
      </ul>
      </div>
      </div>
      </div>

      {/* Law Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Law</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• BA LL.B (Hons.)</li>
      <li>• BBA LL.B (Hons.)</li>
      <li>• LL.B (Hons.)</li>
      <li>• LL.M.</li>
      </ul>
      </div>
      </div>
      </div>

      </div>
      <div className="row mt-4">

      {/* Computer Science Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Computer Science</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• B.Tech.</li>
      <li>• B.Sc.</li>
      <li>• BCA</li>
      <li>• M.Tech</li>
      <li>• MCA</li>
      </ul>
      </div>
      </div>
      </div>

      {/* Business Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Business</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• BBA</li>
      <li>• B.Com. (Hons.)</li>
      <li>• MBA</li>
      <li>• Integrated - (BBA) - (MBA)</li>
      <li>• Integrated - B.Com (Hons) - (MBA)</li>
      </ul>
      </div>
      </div>
      </div>

      {/* Law Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Law</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• BA LL.B (Hons.)</li>
      <li>• BBA LL.B (Hons.)</li>
      <li>• LL.B (Hons.)</li>
      <li>• LL.M.</li>
      </ul>
      </div>
      </div>
      </div>

      </div>
      <div className="row mt-4">

      {/* Computer Science Card */}
      <div className="col-md-4 mt-4">
      <div className="card shadow-sm p-3 mb-4">
      <div className="card-body">
      <h6 className='school'>School of</h6>
      <h4 className="card-title mb-4">Computer Science</h4>
      <hr style={{
      height:"3px",
      backgroundColor:"black"
      }} />
      <ul className="list-unstyled mt-4">
      <li>• B.Tech.</li>
      <li>• B.Sc.</li>
      <li>• BCA</li>
      <li>• M.Tech</li>
      <li>• MCA</li>
      </ul>
      </div>
      </div>
      </div>

      </div>
      </div>
      </section>
      <section className="py-4 mt-5 admission" id='admission'>
      <div className="container mt-4">
      <h2 className="section-title">Admission Criteria</h2>

      {/* School Tabs */}
      <div className="d-flex flex-wrap gap-2 mt-3">
      {schools.map((school) => (
      <button
      key={school.id}
      className={`school-tab btn ${
      selectedSchool === school.id ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => setSelectedSchool(school.id)}
      >
      {school.name}
      </button>
      ))}
      </div>

      {/* Undergraduate & Postgraduate Toggle */}
      <div className="mt-4">
      <span
      className={`tab-switch ${selectedLevel === "undergraduate" ? "active" : ""}`}
      onClick={() => setSelectedLevel("undergraduate")}
      >
      Undergraduate
      </span>
      <span
      className={`tab-switch ${selectedLevel === "postgraduate" ? "active" : ""}`}
      onClick={() => setSelectedLevel("postgraduate")}
      >
      Postgraduate
      </span>
      </div>

      {/* Tab Content */}
      <div className="row mt-3">
      {programs[selectedSchool] && programs[selectedSchool][selectedLevel] ? (
      programs[selectedSchool][selectedLevel].map((program, index) => (
      <div className="col-md-6" key={index}>
      <div className="tab-card border-prime p-5">
      <h4 className="mt-3">
      <b>{program.title}</b>
      </h4>

      <h5 className="mt-4">Eligibility Criteria:</h5>
      {Array.isArray(program.criteria) ? (
      <ul>
      {program.criteria.map((point, idx) => (
      <li className='mt-3' key={idx}>{point}</li>

      ))}

      </ul>
      ) : (
      <p>{program.criteria}</p>
      )}

      <a href="#hero-section"><button className="trans-buttons">Apply Now</button></a>
      </div>
      </div>
      ))
      ) : (
      <p>No programs available.</p>
      )}
      </div>
      </div>
      </section>
      
      <section className='mt-5' id='Achievements'>
      <div className="container mt-5 text-start">
      <h2 className="section-title mb-4">Student Achievements</h2>
      <TestimonialCarousel/>
      </div>
      </section>
      </>
      );
      };

      export default Home;
